import React from 'react'
import './experience.css';
import Imagine from '../../images/logo-imagine.png';
import Uniandes from '../../images/logo-uniandes.png';
import Accenture from '../../images/logo-accenture.png';
import Minci from '../../images/logo-minci.png';
import Tsdl from '../../images/logo-tsdl.png';

export default function Experience()
{
    return(
       <div className="experience-container">
          <p className="title-page">Experience</p>

          <div class="experience" id="Experience">
          <div class="container timeline">
            <ul>
                <li>
                    <h4 class="timeline-title">
                    <img 
                    src={Imagine} 
                    className="tec-cube"
                    alt="uniandes"
                    />
                    <img 
                    src={Uniandes} 
                    className="tec-cube"
                    alt="uniandes"
                    />
                    IMAGINE - Research Group</h4>
                    <div class="step step-active">
                        <div>
                            <div class="circle"></div>
                        </div>
                        <div class="title-exp">Graduate Student Researcher
                            <p class="time-experience">August 2020 - currently</p>
                            <p class="description-experience">
                            I did an study about the use of current virtual reality technologies for requirements gathering in the field of simulation and training. For it,  I used collaborative virtual environments such as Mozilla Hubs and AltspaceVR as a sample of what is currently possible with VR. Also, I did the virtual environments of the teleconferences using technologies like Spoke and Unity 3D.                            </p>                        
                        </div>
                    </div>
                    <div class="step">
                    <div>
                            <div class="circle"></div>
                        </div>
                        <div class="title-exp">Undergraduate Student Researcher
                            <p class="time-experience">August - December 2019 (6 months)</p>
                            <p class="description-experience">
                             I made a prototype of a video game in virtual reality, which seeks to strengthen the skills of patients diagnosed with Attention Deficit Disorder (ADD), through a series of interactive tasks <a target="_blank" href="https://imagine.uniandes.edu.co/projects/Pablo_addScape.html">(ADD Scape)</a>
                            </p>                        
                        </div>
                    </div>
                </li>
                <li>
                    <h4 class="timeline-title">
                    <img 
                    src={Tsdl} 
                    className="tec-cube"
                    alt="accenture"
                    />
                    <img 
                    src={Uniandes} 
                    className="tec-cube"
                    alt="uniandes"
                    />
                    The SW Design Lab - Research Group</h4>
                    <div class="title-exp">SeneCare UI/UX leader
                        <p class="time-experience">June 2020 - currently</p>
                        <p class="description-experience">
                        I am part of the Covid Angel project, from which we created <a target="_blank" href="https://thesoftwaredesignlab.github.io/Senecare/">SeneCare</a>: a digital solution that combines mobile applications and an analytics engine in order to help the community of the Universidad de los Andes to promote care, both personal and of the entire community, having as a guiding principle the privacy of personal information, as well as the veracity of the information provided. In particular, I participated as a UI / UX leader for the mobile application.
                        </p>                        
                    </div>
                </li>
                <li>
                    <h4 class="timeline-title">
                    <img 
                    src={Accenture} 
                    className="tec-cube"
                    alt="accenture"
                    />
                    Accenture</h4>
                    <div class="title-exp">Intern
                        <p class="time-experience">January - July 2020 (6 months)</p>
                        <p class="description-experience">
                         I practiced in the Interaction area, supporting product design and digital transformation, through the creation of wireframes and prototypes. Additionally, I developed a desktop and web app to optimize a process for measuring time and evaluating team metrics, by extracting the calendar data of each user and generating the necessary graphs to evaluate productivity and investment of time. I used technologies like ElectronJS, ReactJS, Firebase, Javascript, Bootstrap, CSS
                        </p>                        
                    </div>
                </li>
                <li>
                    <h4 class="timeline-title">
                    <img 
                    src={Minci} 
                    className="tec-cube"
                    alt="minci"
                    />
                    Minci</h4>
                    <div class="title-exp">Developer
                        <p class="time-experience">December 2019</p>
                        <p class="description-experience">
                        I have participated in the design and development of a video game that supports the main interest of the company, which is to train, support and empower entrepreneurs.
                        </p>                        
                    </div>
                </li>
                <li>
                    <h4 class="timeline-title">
                    <img 
                    src={Uniandes} 
                    className="tec-cube"
                    alt="uniandes"
                    />
                    Universidad de los Andes</h4>
                    <div class="step">
                        <div>
                            <div class="circle"></div>
                        </div>
                        <div class="title-exp">Teaching assistant - Mobile app development
                            <p class="time-experience">August 2019 - July 2020 (11 months)</p>                    
                        </div>
                    </div>
                    <div class="step">
                    <div>
                            <div class="circle"></div>
                        </div>
                        <div class="title-exp">Programming Tutor - Cupitaller
                        <p class="time-experience">January - May 2019 (5 months)</p>                   
                        </div>
                    </div>
                    <div class="step">
                    <div>
                            <div class="circle"></div>
                        </div>
                        <div class="title-exp">Teaching Assistant - APO I
                        <p class="time-experience">August 2018 - May 2019 (10 months)</p>                   
                        </div>
                    </div>
                </li>
            </ul>
        </div>

          </div>
       </div> 
    )
}